"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetListFilter = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const adminClient_1 = require("client/adminClient");
const listFilterKeys_1 = __importDefault(require("consts/queryKeys/listFilterKeys"));
const useGetListFilter = (page, params, options) => {
    const fetchFilter = (olderThan, signal) => {
        return (0, adminClient_1.getListFilter)(Object.assign(Object.assign({}, params), { olderThan }), signal);
    };
    return (0, react_query_1.useInfiniteQuery)(listFilterKeys_1.default.page(page, params), ({ pageParam, signal }) => fetchFilter(pageParam, signal), Object.assign({ getNextPageParam: lastPage => { var _a; return ((_a = lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) || 0; } }, options));
};
exports.useGetListFilter = useGetListFilter;
